import React, { useEffect, useState } from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Auth from '../auth';
import Page404 from '../page404';
import Home from '../home';
import Theme from '../theme';
import Template from '../template';
import Customer from '../customer';
import Employee from '../employee';
import User from '../user';
import ProfilePage from '../profile';
import { isAuth } from '../auth/actions';
import { useHistory } from 'react-router-dom';
// import ComingSoon from "../comingSoon";
// import ProfilePage from "../usersManagement/profile";

function App() {
  let routerUi = <div className='loader-block' />;

  // useEffect(() => {
  //   if (!isAuth()) {
  //     useHistory.push('/auth');
  //   } else if (isAuth().role === 1) {
  //     useHistory.push('/');
  //   }
  // }, []);

  // if (state.initialAuth) {s
  // if (isAuth() && isAuth().role === 1) {
  routerUi = (
    <Router>
      <Switch>
        <Route exact path='/' component={() => <Home />} />
        <Route exact path='/home' component={() => <Home />} />
        {/* <Route path='/auth' component={() => <Redirect to='/home' />} /> */}
        <Route path='/theme-management' component={() => <Theme />} />
        <Route path='/template-management' component={() => <Template />} />
        <Route path='/customer-management' component={() => <Customer />} />
        <Route path='/employee-management' component={() => <Employee />} />
        <Route path='/user-management' component={() => <User />} />
        <Route path='/auth' component={() => <Auth />} />

        <Route path='/profile' component={ProfilePage} />
        {/* <Route path='*' component={() => <Page404 />} /> */}
        <Route
          path='/auth'
          component={() => (isAuth() ? <Redirect to='/' /> : <Auth />)}
        />
        <Route
          path='/'
          component={() => (!isAuth() ? <Redirect to='/auth' /> : <Home />)}
        />
      </Switch>
    </Router>
  );
  // } else {
  //   routerUi = <Auth />;
  // }

  let loadingUi;

  // if (state.isLoading) {
  // loadingUi = <div className="loader-block" />;
  // }

  return (
    <React.Fragment>
      <ToastContainer />
      {loadingUi}
      {routerUi}
    </React.Fragment>
  );
}

export default App;
